"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbsComponent = void 0;
const router_1 = require("@angular/router");
const breadcrumb_1 = require("../../models/subscriberProfile/breadcrumb");
/**
 * Breadcrumbs Component
 */
class BreadcrumbsComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnChanges() {
        this.breadcrumbs = [];
        if (this.breadcrumbs.length <= 0 && this.defaultCrumbs) {
            this.breadcrumbs = this.defaultCrumbs;
        }
    }
    setCategory() {
        return new breadcrumb_1.Breadcrumb();
    }
    handleClick(url, parameters) {
        if (url && !url.includes('/web/')) {
            if (parameters) {
                const queryParams = new URLSearchParams();
                for (const key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        queryParams.append(key, parameters[key]);
                    }
                }
                this.router.navigate([url], { queryParams, queryParamsHandling: 'merge' });
            }
            else {
                this.router.navigate([url]);
            }
        }
    }
}
exports.BreadcrumbsComponent = BreadcrumbsComponent;
//# sourceMappingURL=breadcrumbs.component.js.map